import React from "react";
import logger from "../../../services/Logger";

/**
 * Reusable error boundary for visualization components.
 *
 * @param {string}  title    - Heading shown on error (e.g. "Visualization Render Error")
 * @param {string}  [code]   - Optional source code to display in a <pre> block on error
 * @param {string}  [caller] - Logger label (e.g. "PhysicsViz"), defaults to "VizErrorBoundary"
 * @param {React.ReactNode} children
 */
class VizErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error(this.props.caller || "VizErrorBoundary", "Render Error", {
      error: error.message,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 bg-fill-red-50 dark:bg-fill-red-900/20 border border-edge-red-200 dark:border-edge-red-800 rounded-lg text-ink-red-600 dark:text-ink-red-400 text-sm font-mono">
          <p className="font-bold mb-1">{this.props.title || "Render Error"}</p>
          <p className="text-xs opacity-75">{this.state.error?.toString()}</p>
          {this.props.code && (
            <pre className="mt-2 text-xs opacity-75 overflow-x-auto max-h-32">
              {this.props.code}
            </pre>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}

export default VizErrorBoundary;
